// extracted by mini-css-extract-plugin
export default {"attentionBadge":"attentionBadge__iA8GO"};